const EMAIL_REGEX = /\S+@\S+\.\S+/;

const validateEmail = (value) => EMAIL_REGEX.test((value || '').trim());

export default validateEmail;
